import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Students extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M10.4,7.3c1-0.7,1.6-1.9,1.6-3.2C12,1.8,10.2,0,8,0S3.9,1.8,3.9,4.1c0,1.3,0.7,2.5,1.7,3.3
          C2.8,8.6,2,11.8,2,13.8C2,15.8,6.2,16,8,16s6-0.2,6-2.1C14,11.8,13.2,8.5,10.4,7.3z M8,1.4c1.5,0,2.7,1.2,2.7,2.7S9.4,6.8,8,6.8
          S5.3,5.6,5.3,4.1S6.5,1.4,8,1.4z M8,14.6c-2.9,0-4.4-0.5-4.6-0.7c0-0.6,0.1-5.6,4.6-5.6c4.5,0,4.6,5,4.6,5.5
          C12.4,14,10.9,14.6,8,14.6z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Students.js